import { createTelemetry } from '@shared/core/analytics/telemetry';

const category = 'GuestGuide';

const { TelemetryProvider: GuestGuideTelemetryProvider, useTelemetry: useGuestGuideTelemetry } = createTelemetry({
  pages: {
    remindMeLaterDialog: () => ({
      category,
      name: 'guest.wedding.guestGuide.remindMeLaterDialog',
      page: 'remindMeLaterDialog',
      pagePrefix: 'guest',
    }),
  },
  actions: {
    guideShown: () => ({
      action: 'GuestGuideShown',
      category,
    }),
    clickAddToCalendar: () => ({
      action: 'AddToCalendar',
      actionType: 'click',
      category,
    }),
    clickEditRsvp: () => ({
      action: 'EditRsvp',
      actionType: 'click',
      category,
    }),
    clickCarRentals: () => ({
      action: 'CarRentals',
      actionType: 'click',
      category,
    }),
    clickBrowseHotels: () => ({
      action: 'BrowseHotels',
      actionType: 'click',
      category,
    }),
    clickBrowseRegistry: () => ({
      action: 'BrowseRegistry',
      actionType: 'click',
      category,
    }),
    clickRemindMeToBookStay: () => ({
      action: 'RemindMeToBookStay',
      actionType: 'click',
      category,
    }),
    formFieldInteracted: (label: string, inputAction: 'onFocus' | 'onChange') => ({
      category,
      action: 'FormFieldInteracted',
      label,
      inputAction,
      extraInfo: {
        name: 'remind_to_book',
      },
    }),
    remindMeLaterFormSubmitted: (duration: string, reminderDate: string) => ({
      category,
      action: 'FormSubmitted',
      extraInfo: {
        duration,
        reminderDate,
        name: 'remind_to_book',
      },
    }),
    remindMeLaterDialogDismissed: () => ({
      category,
      action: 'GuestGuideButtonInteracted',
      extraInfo: {
        name: 'remind_to_book_dismiss_cta',
      },
    }),
    remindMeLaterDialogOutsideClick: () => ({
      category,
      action: 'GuestGuideButtonInteracted',
      extraInfo: {
        name: 'remind_to_book_dismiss_click_outside',
      },
    }),
  },
});
export { GuestGuideTelemetryProvider, useGuestGuideTelemetry };
